export default __webpack_public_path__ + "static/media/KR.7269d77f.ico";